import { useQuery } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../orpc'

export function useFbosByAirport(icao?: string) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery({
    ...orpc.fbo.listByAirport.queryOptions({ input: { icao: icao ?? '' } }),
    enabled: !!icao && icao.length >= 3,
    staleTime: 5 * 60 * 1000,
  })
}
